import React from 'react';
import {
  DialogTitle,
  Button,
  DialogActions,
  DialogContent,
  Grid,
  LinearProgress,
  Fab,
  Typography,
  Input
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Dialog from '../Dialog';
import { inputFieldNames } from '../../constants';
import { DatePicker } from '../DatePicker';
import FancyDropDown from '../FancyDropDown';
import { injuryConstants } from '../../constants';

import { utcToLocal } from './../../utils/timeConverter';

import { Attachment as AttachmentIcon } from '@material-ui/icons';
import Attachments from '../Attachments';

import CreatePersonnelDialog from '../../containers/CreatePersonnelDialog';

const useStyles = makeStyles((theme) => ({
  dialog: {},
  dialogTitle: {
    background: '#f0f0f0'
  },
  dialogContent: {
    width: 580,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3)
  },
  actionButton: {
    width: 180,
    float: 'right',
    margin: theme.spacing(2)
  },
  personnelbtn: {
    width: 220,
    float: 'left'
  },
  footer: {
    background: '#f0f0f0'
  },
  picker: {
    margin: 0,
    padding: 0
  }
}));

const CreateEditAccidentFormUi = (props) => {
  const {
    openDialog,
    isSaving,
    onHandleInputChange,
    openCreateAccidentDialog,
    handleSubmit,
    title,
    accident,
    personnels,
    isLoadingPersonnel,
    actionButtonText = 'Add',
    handleRemoveAttachment,
    allAttachments,
    openCreatePersonnelDialog
  } = props;

  const hiddenFileInput = React.createRef();

  const classes = useStyles();

  const onDialogClose = () => {
    openCreateAccidentDialog(false);
  };

  const handleInputChange = (e, inputfieldName) => {
    if (
      inputfieldName === inputFieldNames.INJURY_DATE ||
      inputfieldName === inputFieldNames.INJURY_TIME
    ) {
      onHandleInputChange(e, inputfieldName);
    } else {
      onHandleInputChange(e.target.value, inputfieldName);
    }
  };

  const handleClick = (event) => {
    hiddenFileInput.current.children[0].click();
  };

  const onAttachmendAdded = (event) => {
    event.preventDefault();
    const { onHandleInputChange } = props;
    const file = event.target.files[0];
    const newObj = {
      newlyAdded: true,
      removed: false,
      fileData: file,
      name: file.name
    };
    onHandleInputChange(newObj, inputFieldNames.ACCIDENT_ATTACHMENT);
    hiddenFileInput.current.children[0].value = null;
  };

  return (
    <React.Fragment>

   <CreatePersonnelDialog/>
   
      <Dialog
        open={openDialog}
        onClose={onDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
      >
        {isSaving || isLoadingPersonnel ? <LinearProgress /> : ''}
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          {title}
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent className={classes.dialogContent}>
            <Grid container className={classes.formContainer} spacing={3}>
              <Grid item xs={6}>
                <DatePicker
                  id="injuryDate"
                  htmlId="injuryDate"
                  title="Accident Date"
                  className={classes.picker}
                  handleDateChange={(date) =>
                    handleInputChange(date, inputFieldNames.INJURY_DATE)
                  }
                  selectedDate={
                    actionButtonText === 'Add'
                      ? accident.injuryDate
                      : utcToLocal(accident.injuryDate)
                  }
                  required={true}
                />
              </Grid>
              <Grid item xs={6}></Grid>

              {/* <Grid item xs={6}>
                <TimePicker
                  id="accidentTime"
                  htmlId="accidentTime"
                  title="Accident Time"
                  className={classes.picker}
                  handleDateChange={(date) =>
                    handleInputChange(date, inputFieldNames.INJURY_TIME)
                  }
                  selectedDate={
                    actionButtonText === 'Add'
                      ? accident.injuryTime
                      : utcToLocal(accident.injuryTime)
                  }
                />
              </Grid> */}
              <Grid item xs={6}>
                <FancyDropDown
                  htmlId="injuryLocation"
                  label="Injury Location"
                  margin="normal"
                  value={accident.injuryLocationId}
                  handleChange={(e) =>
                    handleInputChange(e, inputFieldNames.INJURY_LOCATION)
                  }
                  items={injuryConstants.injuryLocations}
                  dropDownWidth="100%"
                  className={classes.dropDown}
                  valueField="id"
                  displayField="value"
                />
              </Grid>
              <Grid item xs={6}>
                <FancyDropDown
                  htmlId="injuryType"
                  label="Injury Type"
                  margin="normal"
                  value={accident.injuryTypeId}
                  handleChange={(e) =>
                    handleInputChange(e, inputFieldNames.INJURY_TYPE)
                  }
                  items={injuryConstants.injuryTypes}
                  dropDownWidth="100%"
                  className={classes.dropDown}
                  valueField="id"
                  displayField="value"
                />
              </Grid>
              <Grid item xs={6}>
                <FancyDropDown
                  htmlId="injuryCause"
                  label="Injury Cause"
                  margin="normal"
                  value={accident.injuryCauseId}
                  handleChange={(e) =>
                    handleInputChange(e, inputFieldNames.INJURY_CAUSE)
                  }
                  items={injuryConstants.injuryCauses}
                  dropDownWidth="100%"
                  className={classes.dropDown}
                  valueField="id"
                  displayField="value"
                />
              </Grid>
              <Grid item xs={6}/>
              <Grid item xs={6}>
                <FancyDropDown
                  htmlId="personnelList"
                  label="Personnel"
                  margin="normal"
                  value={accident.personnelId}
                  handleChange={(e) =>
                    handleInputChange(e, inputFieldNames.PERSONNEL)
                  }
                  items={personnels}
                  dropDownWidth="100%"
                  className={classes.dropDown}
                  valueField="id"
                  displayField={['firstName', 'lastName']}
                />
              </Grid>

              <Grid item xs={6}>
              <Grid item xs={12} varient = "body1">
                <Typography className={classes.label}>Non Staff Member?</Typography>
              </Grid>
              <Button
              onClick={() => openCreatePersonnelDialog(true)}
              color="primary"
              variant="contained"
              className={classes.personnelbtn}
              id="addChildButton"
              // disabled={!enableAddButton}
            >
             Add Non Staff Member
            </Button>
              </Grid>

              {/***************** Attachment ******************/}
              <Grid item xs={12} className={classes.gridItem}>
                <Typography className={classes.label}>Attachments</Typography>
              </Grid>
              <Grid item xs={12} className={classes.gridItem}>
                <Fab
                  id="addAttachmentBtn"
                  color="primary"
                  variant="extended"
                  aria-label="add"
                  onClick={handleClick}
                  className={`${classes.addAttachmentFab} ${classes.button}`}
                >
                  <AttachmentIcon className={classes.extendedIcon} />
                  Add attachment
                  <Input
                    type="file"
                    ref={hiddenFileInput}
                    multiple={false}
                    onChange={onAttachmendAdded}
                    style={{ display: 'none' }}
                  />
                </Fab>
              </Grid>
              {allAttachments && (
                <Grid item xs={12} className={classes.gridItem}>
                  <Attachments
                    allAttachments={allAttachments}
                    onRemoveAttachment={handleRemoveAttachment}
                  />
                </Grid>
              )}
            </Grid>
          </DialogContent>
          <DialogActions className={classes.footer}>
            <Button
              onClick={onDialogClose}
              color="primary"
              variant="outlined"
              className={classes.actionButton}
              id="cancelButton"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={classes.actionButton}
              id="addChildButton"
              // disabled={!enableAddButton}
            >
              {actionButtonText}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

export default CreateEditAccidentFormUi;
